module.exports = __webpack_public_path__ + "img/bg_shelter.006092c8.jpg";